import styled, { keyframes } from "styled-components";

const livePulse = keyframes`
  50% { box-shadow: 0 0 0 6px rgba(75,181,67,0); }
`;

export const LiveIndicatorStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;

  .meta-row {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 12px;
  }

  .meta-label {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    text-transform: uppercase;
    letter-spacing: 0.2px;
    font-size: 10px;
  }

  .meta-value {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    font-variant-numeric: tabular-nums;
  }

  .meta-status {
    color: ${({ theme }) => theme.colors.success[700]};
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }

  .meta-status i {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.success[500]};
    display: inline-block;
    box-shadow: 0 0 0 3px rgba(75, 181, 67, 0.15);
    animation: ${livePulse} 2s ease-in-out infinite;
  }
`;
